import { cn } from '../../../lib/styles';
import { Button } from '../button/button.spark';
import { Heading } from '../heading/heading.spark';
import { Text } from '../text/text.spark';
import type { MediaCardProps } from './types';

export function MediaCard({
  title,
  description,
  action,
  headingLevel,
  imgSrc,
  imgFit = 'cover',
  illustration,
  buttonClassName,
}: MediaCardProps) {
  return (
    <section className="flex h-full flex-col overflow-hidden rounded-lg border border-spark-border-subtle bg-spark-surface shadow-sm sm:flex-row">
      {illustration ? (
        <div className="h-32 w-full min-w-0 bg-spark-surface-muted *:block *:size-full sm:h-full sm:w-1/4">
          {illustration}
        </div>
      ) : (
        <img
          alt=""
          className={cn(
            'h-32 w-full min-w-0 bg-spark-surface-muted object-center sm:h-full sm:w-1/4',
            imgFit === 'contain' ? 'object-contain' : 'object-cover',
          )}
          src={imgSrc}
        />
      )}
      <div className="flex flex-1 shrink-0 flex-col gap-1.5 p-4">
        <Heading style="sm" level={headingLevel}>
          {title}
        </Heading>
        <Text size="md" variant="secondary">
          {description}
        </Text>
        <div className="mt-auto">
          <Button
            className={buttonClassName}
            variant="secondary"
            onClick={action.onClick}
            icon={action.icon}
          >
            {action.content}
          </Button>
        </div>
      </div>
    </section>
  );
}
